import React, { useState } from 'react';
import LeadEditModal from '../components/AdminLeadsPage/LeadEditModal';
import LeadAddModal from '../components/AdminLeadsPage/LeadAddModal';
import LeadDeleteModal from '../components/AdminLeadsPage/LeadDeleteModal';
import SearchFilter from '../components/SearchFilter/SearchFilter';
import LeadsTable from '../components/AdminLeadsPage/LeadsTable';
import LeadsIntroActions from '../components/AdminLeadsPage/LeadsIntroActions';
import LeadsBulkActions from '../components/AdminLeadsPage/LeadsBulkActions';
import useLeadActions from '../hooks/AdminLeadsPage/useLeadActions';
import AdminTableLoadingSpinner from '../components/Common/AdminTableLoadingSpinner';
import '../styles/AdminBulkActions.css';

const AdminLeadsPage = () => {
  const [editLead, setEditLead] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [deleteLead, setDeleteLead] = useState(null);

  const {
    leads,
    filteredLeads,
    selectedLeads,
    clearSelectedLeads,
    loadLeads,
    boats,
    handleExport,
    handleFilter,
    handleSelectAll,
    handleLeadSelect,
    isLoading
  } = useLeadActions();

  return (
    <div className="admin-page">
      <div className="admin-page__intro">
        <h1>Leads</h1>
        <LeadsIntroActions leads={leads} />
      </div>

      <div className="admin-page__content">
        <div className="admin-page__tools">
          <SearchFilter onFilter={handleFilter} />
          <LeadsBulkActions
            selectedLeads={selectedLeads}
            onExport={handleExport}
            clearSelectedLeads={clearSelectedLeads}
            loadLeads={loadLeads}
          />
          <div className="admin-page__tools_buttons">
            <button className="button primary" onClick={() => setIsAddModalOpen(true)}>
              Add Lead
            </button>
          </div>
        </div>

        {isLoading ? (
          <AdminTableLoadingSpinner />
        ) : (
          <>
            <LeadsTable
              leads={filteredLeads}
              onEdit={setEditLead}
              onDelete={setDeleteLead}
              onLeadSelect={handleLeadSelect}
              selectedLeads={selectedLeads}
              onSelectAll={handleSelectAll}
            />
            <div className="admin-page__footer">
              <p>Leads count: {filteredLeads.length}</p>
            </div>
          </>
        )}

      </div>

      <LeadEditModal
        isOpen={!!editLead}
        onClose={() => setEditLead(null)}
        onSuccess={() => {
          loadLeads();
          setEditLead(null);
        }}
        lead={editLead}
        boats={boats}
      />

      <LeadAddModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onSuccess={() => {
          loadLeads();
          setIsAddModalOpen(false);
        }}
        boats={boats}
      />

      <LeadDeleteModal
        isOpen={!!deleteLead}
        onClose={() => setDeleteLead(null)}
        onSuccess={() => {
          loadLeads();
          setDeleteLead(null);
        }}
        lead={deleteLead}
      />
    </div>
  );
};

export default AdminLeadsPage;